/**
 * Consent copy and versioning, frontend side.
 *
 * These strings are the single source of truth for what the user is shown, and
 * the backend captures them verbatim into consent_records.consent_text at the
 * moment of submission. Mirrors
 * zampliasurveysbackend/src/services/consent/consent-constants.ts -- if you
 * change one, change both, and bump POLICY_VERSION.
 *
 * Deliberately NOT an i18n key. The audit record has to hold the exact wording
 * shown, and an i18n lookup resolves differently per locale and can change under
 * a record that has already been written. Translations may be layered on for
 * display later, but the recorded English text stays canonical.
 */

/**
 * Policy version stamped on every consent record.
 *
 * Anchored to the effective date of the published privacy policy (rendered from
 * the i18n key `page.policy.Effective` -- "This version: Effective 13 March
 * 2023"). Bump when the policy text or the consent wording changes.
 */
export const POLICY_VERSION = "2023-03-13";

/** Registration checkbox label. Shown verbatim, recorded verbatim. */
export const REGISTRATION_MARKETING_CONSENT_TEXT =
  "Yes, I'd like to receive survey invitations, reward updates, and occasional promotional emails from Zamplia Surveys. I can unsubscribe at any time.";

/** Helper text rendered below the checkbox. */
export const REGISTRATION_MARKETING_HELPER_TEXT =
  "You can update your email preferences or unsubscribe at any time.";
